// The 8 fixed categories (D12, seeded in T-103b). Names are i18n keys `categories.<slug>`;
// colors are the `--color-cat-<slug>` tokens. Never show a color without its icon (DESIGN).
import {
	Dices,
	Dumbbell,
	Handshake,
	Martini,
	Music,
	Palette,
	Plane,
	UtensilsCrossed,
	type LucideIcon,
} from 'lucide-react';

export const CATEGORY_SLUGS = [
	'sport',
	'party',
	'meet',
	'food',
	'music',
	'games',
	'travel',
	'hobby',
] as const;

export type CategorySlug = (typeof CATEGORY_SLUGS)[number];

/** Category icons (lucide, T-306a). Always shown with the category color, never color alone. */
export const CATEGORY_ICONS: Record<CategorySlug, LucideIcon> = {
	sport: Dumbbell,
	party: Martini,
	meet: Handshake,
	food: UtensilsCrossed,
	music: Music,
	games: Dices,
	travel: Plane,
	hobby: Palette,
};

/** Big emoji for the create tiles (T-1320); the map keeps the lucide icons. */
export const CATEGORY_EMOJI: Record<CategorySlug, string> = {
	sport: '⚽',
	party: '🎉',
	meet: '🤝',
	food: '🍕',
	music: '🎵',
	games: '🎲',
	travel: '✈️',
	hobby: '🎨',
};

export function isCategorySlug(value: string): value is CategorySlug {
	return (CATEGORY_SLUGS as readonly string[]).includes(value);
}

// Literal class names so Tailwind generates them (tokens only, no raw hex).
export const CATEGORY_TEXT: Record<CategorySlug, string> = {
	sport: 'text-cat-sport',
	party: 'text-cat-party',
	meet: 'text-cat-meet',
	food: 'text-cat-food',
	music: 'text-cat-music',
	games: 'text-cat-games',
	travel: 'text-cat-travel',
	hobby: 'text-cat-hobby',
};

/** Cover / marker gradient start per category (generated covers, T-306c). */
export const CATEGORY_FROM: Record<CategorySlug, string> = {
	sport: 'from-cat-sport',
	party: 'from-cat-party',
	meet: 'from-cat-meet',
	food: 'from-cat-food',
	music: 'from-cat-music',
	games: 'from-cat-games',
	travel: 'from-cat-travel',
	hobby: 'from-cat-hobby',
};
